import classnames from 'classnames';
import { MyLink } from '@/components/MyLink';
import Icon from './icon_info.svg?react';
import s from './index.module.scss';

const TYPE = {
  info: 'info',
  action: 'action',
  error: 'error',
  success: 'success',
};

export const InfoMessage = ({
  title,
  description,
  linkLabel,
  linkUrl,
  linkState,
  type = TYPE.info,
}) => {
  return (
    <div className={classnames(s.wrapper, type)}>
      <Icon className={classnames(s.icon, type)} />
      <div className={s.content}>
        <div className={s.title}>{title}</div>
        {description && <div className={s.desc}>{description}</div>}
      </div>
      {linkUrl && (
        <MyLink className={s.link} href={linkUrl} state={linkState}>
          {linkLabel || linkUrl}
        </MyLink>
      )}
    </div>
  );
};
